<script>
import { displayToast, handleResponseError } from '@/components/utils/globalFunction'
import { auth as $store } from '@/store/AuthModule'
import RepairFileService from '@/services/RepairFileService'
import { RepairFile } from '@/models/RepairFile'
import DialogBackButton from '@/components/modal/DialogBackButton.vue'

export default {
  name: 'AddAttachmentPcComponent',
  components: { DialogBackButton },
  props: {
    currentRepairFileProps: RepairFile,
    attachmentTypeProps: String,
    attachmentFileProps: String
  },
  data() {
    return {
      loading: false,

      currentRepairFile: null,
      attachmentType: null,
      attachmentFile: null,

      error: null,

      validateButton: undefined,
    }
  },
  created() {
    this.currentRepairFile = this.currentRepairFileProps
    this.attachmentFile = this.attachmentFileProps
    this.attachmentType = this.attachmentTypeProps
  },
  methods: {
    async back() {
      this.error = {}
      this.$emit('back-to-parent-page')
    },
    async addAttachment() {
      this.loading = true
      const repairFileId = this.currentRepairFile.technical_id
      try {
        const data = {
          'repairFileId': repairFileId,
          'attachmentType': this.attachmentType,
          'requesterCollaboratorId': $store.state.currentCollaborator.technical_id,
        }
        const formData = new FormData()
        formData.append('data', JSON.stringify(data))
        if (this.attachmentFile) {
            formData.append('attachmentFile', this.attachmentFile)
        }
        await RepairFileService.addAttachmentFile(formData)
        displayToast(this.$t('COMMON.MESSAGE.ADD_ATTACHMENT_SUCCESS'), 'success')
        this.attachmentFile = null
        this.$emit('back-to-parent-page')
      } catch (error) {
        handleResponseError(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<template>
  <v-form ref="form" @submit.prevent="addAttachment">
    <DialogBackButton :back-method="back" />

    <div>
      <div class="content-title">
        {{ $t('ATTACHMENT_MODAL.PC_MODAL.TITLE') }}
      </div>

      <div class="mt-8 mb-4 content detail-content">
        <p class="sub-title">
          {{ $t('ATTACHMENT_MODAL.PC_MODAL.MESSAGE') }}
        </p>
      </div>

      <div v-if="attachmentFile !== null" class="mt-2 mb-4 content detail-content">
        <p class="sub-title">
          {{ $t('ATTACHMENT_MODAL.PC_MODAL.MESSAGE_WARNING') }}
        </p>
      </div>

      <v-file-input
        class="mt-3 mb-4"
        :label="$t('ATTACHMENT_MODAL.PC_MODAL.INPUT_LABEL')"
        accept=".pdf, .jpg, .png"
        append-inner-icon="mdi-download"
        chips
        counter
        show-size
        v-model="attachmentFile"
      />

      <!--Send button-->
      <div class="d-flex justify-center">
        <v-btn
          :disabled="attachmentFile === null || loading"
          :loading="loading"
          class="boom-button dialog-button"
          variant="outlined"
          type="submit"
        >
          {{ $t('COMMON.BUTTON.SAVE') }}
        </v-btn>
      </div>
    </div>
  </v-form>
</template>

<style scoped>
.dialog-button {
  min-width: 200px;
}

.content-title {
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.content {
  display: flex;
  justify-content: center;
}

.detail-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.sub-title {
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
</style>
